import { UPDATE_FACILITY } from './graphql/company.updateFacility';
import ApolloProvider from 'es/core/net/ApolloProvider';
import Guid from 'es/core/types/Guid';
import {
    UpdateFacilityMutation,
    UpdateFacilityMutationVariables,
    UpdateFacilityPatch,
} from 'es/app/__generated__/global';

export async function updateFacility(
    facilityId: Guid,
    originalCompanyAlias: string,
    patch: UpdateFacilityPatch
): Promise<boolean> {
    const { data } = await ApolloProvider.company(originalCompanyAlias).mutate<
        UpdateFacilityMutation,
        UpdateFacilityMutationVariables
    >({
        mutation: UPDATE_FACILITY,
        variables: {
            facilityId,
            patch,
        },
    });
    return data?.company.facility.update ?? false;
}
